export const Grid = (function ($) {
  "use strict";

  /* =================== public methods ================== */
  var container;

  // main init method
  function Init() {
    container = $("#grid");

    var posts = document.querySelectorAll(".box-wrapper");
    //console.log("boilerplate module init");
  }

  function AddItems(elem) {
    //$('#grid').append(elem);
    var elements = $.parseHTML(elem);

    $.each(elements, function (index, element) {
      container.append(element);
    });

    var posts = document.querySelectorAll(".box.hidden");

    $(".ajax-more.loading").parent().remove();
  }

  /* =============== export public methods =============== */
  return {
    Init: Init,
    AddItems: AddItems,
  };
})(jQuery);
